
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('LawSuit')
export class LawSuit {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('year', Number, true)
    year: number = undefined;

    @JsonProperty('number', Number, true)
    number: number = undefined;

    @JsonProperty('number_year', String, true)
    claim: string = null;

    get lawsuit() {
        return `${this.number}/${this.year}`;
    }
}